import { useState, type FormEvent } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { useAuth } from './AuthProvider'
import { BrandLockup } from '../../components/Brand'

interface LocationState {
  from?: { pathname?: string }
}

export function LoginPage() {
  const { user, signIn, authConfigured } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)

  if (user) return <Navigate to="/app" replace />

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    setSubmitting(true)
    setError('')
    try {
      await signIn(email, password)
      const state = location.state as LocationState | null
      navigate(state?.from?.pathname || '/app', { replace: true })
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : 'Não foi possível entrar.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <main className="auth-page">
      <section className="auth-card" aria-labelledby="login-title">
        <Link className="auth-back" to="/">← Voltar ao site</Link>
        <BrandLockup className="auth-brand" />
        <p className="eyebrow">SUA OPERAÇÃO EM UM SÓ FLUXO</p>
        <h1 id="login-title">Entre na sua conta</h1>
        <p className="muted">Use suas credenciais para acessar sua organização.</p>
        {!authConfigured && <p className="error" role="status">O acesso será liberado quando a autenticação do ambiente for configurada.</p>}

        <form onSubmit={submit} className="stack">
          <label>
            Email
            <input type="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} required />
          </label>
          <label>
            Senha
            <input type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} required />
          </label>
          {error && <p className="error" role="alert">{error}</p>}
          <button type="submit" disabled={submitting || !authConfigured}>{submitting ? 'Entrando…' : 'Entrar'}</button>
        </form>
        <p className="auth-footer">Ainda não possui conta? <Link to="/cadastro">Criar conta</Link></p>
      </section>
    </main>
  )
}
